module.exports = {
	data() {
		return {
		}
	},
	created: function () {
		return true;
	},
	methods: {
		makeRequest: function() {
			
		},
		setUptimeMonitor: function (data) {
			let that = this
			if((data.table == 'HOSTING' && (!data.HO_WP_BASEURL || data.HO_WP_BASEURL == '')) || (data.table == 'SERVER' && (!data.M_WP_URL || data.M_WP_URL == '')) ) {
				alert("No URL available for this domain: ")
				return false
			}
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post("/monitors/set", data, headers)
			.then(function (response) {
				let msg = (data.action == "add") ? "Added" : "Deleted"
				let typefieldname = data.type.toUpperCase()
				typefieldname = (data.M_ID) ? 'M_MONITOR_' + typefieldname : 'HO_MONITOR_' + typefieldname
				let id = response.id;
				that[typefieldname] = id
				if(response.data.Error) {
					that.$toastr.Add({
						title: "ERROR", // Toast Title
						msg: response.data.Error,
						position: "toast-top-center",
						type: "error"
					});
					return "X"
				}
				else {
					that.$toastr.Add({
						title: "Success", // Toast Title
						msg: msg + " monitor",
						position: "toast-top-center",
						type: "success"
					});
					return "Y"
				}
				// console.log(response)
				
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showadder = false;
				//  console.log(error)
				 return "ERR";
			})
		},
	}
}